import { Component, OnInit } from '@angular/core';
import { authenticationService } from 'src/app/Services/Authentication/authentication.service';
import { ViewController } from '@ionic/core';
import { PopoverController } from '@ionic/angular';
import { SharedService } from 'src/app/Services/sheared/sharedService.service';
import { Router } from '@angular/router';
import { CotationService } from 'src/app/Services/Cotation/cotation.service';



@Component({
  selector: 'app-popovercompo2',
  templateUrl: './popovercompo2.component.html',
  styleUrls: ['./popovercompo2.component.scss'],
})
export class PopovercompoComponent2 implements OnInit {
menu:boolean
  constructor(private viewCtrl:PopoverController,private _router:Router ,
              private auth:authenticationService,private _cotationService:CotationService) {
 
   }

  ngOnInit() {}

    

  onHistorique(){
    if (this._cotationService.navig.value=="/") {
      this._router.navigate(['cotationhistorique'])
    } else {
      this._router.navigate(['/home/menu/cotationhistorique'])
    }
   
    this.viewCtrl.dismiss();
  }
  onResponse(){
    if (this._cotationService.navig.value=="/") {
      this._router.navigate(['cotationresponse'])
    } else {
      this._router.navigate(['/home/menu/cotationresponse'])
    }
    
    //
    this.viewCtrl.dismiss();
  }
}
